<template>
  <div :class="{ small: $vuetify.breakpoint.smAndDown }">
    <!-- <h1 class="grey--text grey--lighten-1 subheading pa-3"
        v-html="$t('parkingDetail.pricing.title', { minutePrice: minutePrice })"></h1> -->

    <v-list subheader class="parkingProducts pt-3" v-if="!isOnlySubscription">
      <v-list-tile avatar :to="{ path: $t('urlLogin') }">
        <v-btn class="accent accent--text" round block large outline>
          <v-list-tile-avatar
            class="font-weight-black pr-3 align-self-center text-none"
            style="justify-content: flex-end"
            :class="{
              title: $vuetify.breakpoint.smAndDown,
              headline: $vuetify.breakpoint.mdAndUp,
            }"
          >
            {{ parking.hourPriceWithCurrency }}/h
          </v-list-tile-avatar>
          <v-list-tile-content class="align-self-center">
            <v-list-tile-title
              class="text-none"
              :class="{
                subheading: $vuetify.breakpoint.smAndDown,
                title: $vuetify.breakpoint.mdAndUp,
              }"
            >
              {{ $t('parkingDetail.pricing.option.hours') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-btn>
      </v-list-tile>
    </v-list>

    <template v-if="hasPlans">
      <v-list subheader class="parkingProducts">
        <v-list-tile
          avatar
          v-for="t in parking.plans"
          :key="t.type"
          :to="{ path: $t('urlLogin') }"
        >
          <v-btn class="accent accent--text" round block large outline>
            <v-list-tile-avatar
              class="font-weight-black pr-3 align-self-center"
              style="justify-content: flex-end"
              :class="{
                title: $vuetify.breakpoint.smAndDown,
                headline: $vuetify.breakpoint.mdAndUp,
              }"
            >
              {{ t.price }}
            </v-list-tile-avatar>
            <v-list-tile-content class="align-self-center">
              <v-list-tile-title
                class="text-capitalize"
                :class="{
                  subheading: $vuetify.breakpoint.smAndDown,
                  title: $vuetify.breakpoint.mdAndUp,
                }"
              >
                {{ t.planName }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-btn>
        </v-list-tile>
      </v-list>
    </template>
  </div>
</template>

<script>
import store from '@/store';
import _ from 'lodash';

export default {
  name: 'ParkingPricing',
  props: {
    parking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    minutePrice() {
      let price = store.state.countrySelected.prices.minute;
      return this.$options.filters.addCurrencySymbol(price);
    },
    isOnlySubscription() {
      return this.parking.onlySubscription;
    },
    hasPlans() {
      if (
        _.isEmpty(this.parking) ||
        _.isEmpty(this.parking.plans)
      ) {
        return false;
      }
      return this.parking.plans.length > 0;
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.parkingProducts .v-avatar {
  width: auto !important;
  height: auto !important;
}

.parkingProducts .v-list__tile__avatar {
  min-width: 150px;
}

.small .parkingProducts .v-list__tile__avatar {
  min-width: 130px;
}
</style>
